import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';

import { gqlRemoveOtherFromOrder, removeActKC2OtherFromWorkOrder } from '../workOrderQueries';

export const useWorkOrderOtherDelete = ({ isActOther }: { isActOther: boolean }) => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [deleteActKC2OtherData, deleteActKC2OtherStatus, deleteActKC2OtherError, deleteActKC2OtherActionCreator] =
        useRequest({
            requestId: 'removeOtherFromWorkOrder',
            query: removeActKC2OtherFromWorkOrder,
            withEffect: false,
        });

    const [
        deleteOtherFromOrderData,
        deleteOtherFromOrderStatus,
        deleteOtherFromOrderError,
        deleteOtherFromOrderActionCreator,
    ] = useRequest({
        requestId: 'removeOtherFromWorkOrder',
        query: gqlRemoveOtherFromOrder,
        withEffect: false,
    });

    const [resetRemovedData] = useResetStoreData({ requestId: 'removeOtherFromWorkOrder' });

    useEffect(() => {
        if (
            RequestStatus.SUCCESS &&
            (deleteActKC2OtherData?.uerRemoveActKC2OtherFromWorkOrder?.message ||
                deleteOtherFromOrderData?.uerRemoveOtherFromWorkOrder?.message)
        ) {
            setIsSubmitted(true);
        }
    }, [
        deleteActKC2OtherData?.uerRemoveActKC2OtherFromWorkOrder?.message,
        deleteOtherFromOrderData?.uerRemoveOtherFromWorkOrder?.message,
    ]);

    const handleCloseModalError = useCallback(() => {
        setIsSubmitted(false);
        resetRemovedData(null);
    }, [resetRemovedData, setIsSubmitted]);

    const handleCreateReport = useCallback(
        () =>
            isActOther
                ? ExportCSVReport(deleteActKC2OtherData?.uerRemoveActKC2OtherFromWorkOrder?.validation)
                : ExportCSVReport(deleteOtherFromOrderData?.uerRemoveOtherFromWorkOrder?.validation),
        [
            deleteActKC2OtherData?.uerRemoveActKC2OtherFromWorkOrder?.validation,
            deleteOtherFromOrderData?.uerRemoveOtherFromWorkOrder?.validation,
            isActOther,
        ],
    );

    return {
        isSubmitted,
        deleteData: isActOther
            ? deleteActKC2OtherData?.uerRemoveActKC2OtherFromWorkOrder
            : deleteOtherFromOrderData?.uerRemoveOtherFromWorkOrder,
        deleteStatus: isActOther ? deleteActKC2OtherStatus : deleteOtherFromOrderStatus,
        deleteError: isActOther ? deleteActKC2OtherError : deleteOtherFromOrderError,
        deleteActionCreator: isActOther ? deleteActKC2OtherActionCreator : deleteOtherFromOrderActionCreator,
        resetRemovedData,
        handleCloseModalError,
        handleCreateReport,
    };
};
